"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by cuppi on 2017/9/6.
 */
const JNetwork_1 = require("./JNetwork");
class JNetworkRoot {
    constructor() {
        this.otherParas = [];
        this.otherHeaders = [];
    }
    static useParas(...paras) {
        let instance = new this();
        instance.otherParas = paras;
        return instance;
    }
    static useHeaders(...headers) {
        let instance = new this();
        instance.otherHeaders = headers;
        return instance;
    }
    useParas(...paras) {
        this.otherParas = paras;
        return this;
    }
    useHeaders(...headers) {
        this.otherHeaders = headers;
        return this;
    }
    static instance() {
        if (!this._instance) {
            this._instance = new this();
            this._instance.test = Math.random();
        }
        return this._instance;
    }
    prefixPromise(url, paras, headers, options) {
        return JNetwork_1.default.useParas(...this.otherParas).useHeaders(...this.otherHeaders).POST(url, paras, headers).then(data => {
            return data;
        });
    }
}
exports.default = JNetworkRoot;
